<template>
  <div class="sec-banner">
    <img src="../../assets/banner.jpg" alt="为亿万家庭主食安全服务" />
    <div class="sec-lead container" :style="'background:'+backgroundC+';'">
      <h1 class="zh-title">{{zhTitle}}</h1>
      <h2 class="en-title">{{enTitle}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sec-banner',
  props: {
    zhTitle: '',
    enTitle: '',
    backgroundC: {
      type: String,
      default: '#ffffff'
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.sec-banner {
  position: relative;
  img {
    // height: 336px;
  }
  .sec-lead {
    position: relative;
    z-index: 2;
    margin-top: -90px;
    width: 690px;
    border-radius: 10px 10px 0 0;
    padding: 62px 0 40px;
    text-align: center;
    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 74px;
      top: 100px;
      width: 126px;
      height: 2px;
      background-color: rgba(1, 175, 170, 1);
    }
    &::after {
      left: auto;
      right: 74px;
    }
    .zh-title {
      font-family: PingFang-SC-Bold;
      font-size: 38px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 50px;
      letter-spacing: 0px;
      color: rgba(1, 175, 170, 1);
      margin-bottom: 25px;
    }
    .en-title {
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 0px;
      color: rgba(1, 175, 170, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/sec-banner.vue